var map = {
	"./certificate.png": "293f",
	"./guarantee.png": "a8d5",
	"./icons": "57ac",
	"./icons.js": "57ac",
	"./logo": "5968",
	"./logo.js": "5968",
	"./waiting.png": "280c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";